import React, { createContext, useContext, useState, useCallback } from "react";
import { translations, LANGS } from "@/i18n";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("en");
  const t = translations[lang];
  const change = useCallback((l) => {
    if (LANGS.includes(l)) setLang(l);
  }, []);
  return (
    <LanguageContext.Provider value={{ lang, setLang: change, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
